import './PatientInformation.scss';

import get from 'lodash/get';
import { useContext, useMemo } from 'react';

import { Context } from '@store/store';
import { firstLetterCapsOnly } from '@utils/helpers';

import PatientInfoCard from './PatientInfoCard';

const PatientInformation = () => {
  const [state] = useContext(Context);

  const userInfo = useMemo(() => state.userInfo, [state.userInfo]);
  const patientDetailsData = useMemo(
    () => [
      [
        { label: 'First name', value: get(userInfo, 'name.first', '') },
        { label: 'Middle name', value: get(userInfo, 'name.middle', '') },
        { label: 'Last name', value: get(userInfo, 'name.last', '') },
      ],
      [
        { label: 'Sex', value: firstLetterCapsOnly(get(userInfo, 'demographics.sex', '')) },
        { label: 'Date of birth', value: get(userInfo, 'demographics.dob', '') },
      ],
    ],
    [userInfo],
  );
  const shippingAddressData = useMemo(
    () => [
      [
        { label: 'Street address', value: get(userInfo, 'contact_info[0].address.street_address', '') },
        { label: 'Address line 2', value: get(userInfo, 'contact_info[0].address.street_address2', '') },
      ],
      [
        { label: 'City', value: get(userInfo, 'contact_info[0].address.city', '') },
        { label: 'Region', value: get(userInfo, 'contact_info[0].address.region', '') },
        { label: 'Postal code', value: get(userInfo, 'contact_info[0].address.postal_code', '') },
      ],
    ],
    [userInfo],
  );
  const contactInformationData = useMemo(
    () => [
      [
        { label: 'Phone number', value: get(userInfo, 'contact_info[0].phone', '') },
        { label: 'Email', value: get(userInfo, 'contact_info[0].email', '') },
      ],
    ],
    [userInfo],
  );

  return (
    <div className='d-flex flex-column patient-information'>
      <PatientInfoCard title='Patient Details' data={patientDetailsData} />
      <PatientInfoCard title='Shipping Address' data={shippingAddressData} />
      <PatientInfoCard title='Contact Information' data={contactInformationData} />
    </div>
  );
};

export default PatientInformation;
